import { render, staticRenderFns } from "./OrgDashboardStatsShipperUi.vue?vue&type=template&id=d5f76d0c&scoped=true&"
import script from "./OrgDashboardStatsShipperUi.vue?vue&type=script&lang=js&"
export * from "./OrgDashboardStatsShipperUi.vue?vue&type=script&lang=js&"
import style0 from "./OrgDashboardStatsShipperUi.vue?vue&type=style&index=0&id=d5f76d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f76d0c",
  null
  
)

export default component.exports